<form novalidate [formGroup]="form" class="needs-validation">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <label class="col-md-12 col-form-label">Ejercicio</label>
                <div class="col-md-12">
                    <select id="id" class="form-control" formControlName="year">
                        <option [value]="null" >- Seleccionar -</option>
                        <option *ngFor="let year of ListaAnios" [value]="year">{{year}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="row">
                <label class="col-md-12 col-form-label">Semana</label>
                <div class="col-md-12">
                    <select id="id" class="form-control" formControlName="week">
                        <option [value]="null">- Seleccionar -</option>
                        <option *ngFor="let week of ListaSemanas" [value]="week">{{week}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</form>